type ErrorMessageProps = {
    errors?: string[];
  };
  
  const ErrorMessage = ({ errors }: ErrorMessageProps) => {
    if (!errors || errors.length === 0) return null;
    
    return (
      <div className="text-danger mt-1">
        {errors.map((error, index) => (
          <div key={index}>{error}</div>
        ))}
      </div>
    );
  };

  export default ErrorMessage;